module.exports = __webpack_public_path__ + "media/images/product_owners/pm_mc_90-114dd3d67cb450cefa3ed42c517e39e0.png";